import { Box } from "@mui/material"
import type { FC } from "react"
import React, { useMemo } from "react"
import { useFormContext } from "react-hook-form"

import { ShippingTermsFieldGroup } from "@/components/Forms"
import { FormSelect } from "@/components/UiKit"
import type { PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"
import type { SpecialPriceSchemaFormValues } from "@/screens/Pricing/schema/SpecialPriceSchema"
import { mapPriceChangeLookupItemsToOptions } from "@/screens/Pricing/utils/lookup"

interface AddSpecialPriceFormProps {
  customers?: PriceChangeFilterLookupItem[]
  shipFromWarehouseAreas?: PriceChangeFilterLookupItem[]
}

export const AddSpecialPriceForm: FC<AddSpecialPriceFormProps> = ({ customers, shipFromWarehouseAreas }) => {
  const { control } = useFormContext<SpecialPriceSchemaFormValues>()

  const customerOptions = useMemo(() => mapPriceChangeLookupItemsToOptions(customers), [customers])
  const shipFromOptions = useMemo(
    () => mapPriceChangeLookupItemsToOptions(shipFromWarehouseAreas),
    [shipFromWarehouseAreas]
  )

  return (
    <form>
      <Box className='flex flex-col gap-3'>
        <FormSelect
          control={control}
          name='customerId'
          label='Customer'
          required
          placeholder='Select Customer'
          options={customerOptions}
          data-testid='pricing.add-special-price.customer-field'
        />

        <FormSelect
          control={control}
          required
          name='shipFrom'
          label='Ship From'
          placeholder='Select Ship From'
          options={shipFromOptions}
          data-testid='pricing.add-special-price.ship-from-field'
        />

        <ShippingTermsFieldGroup
          testIdPrefix='pricing.add-special-price'
          fieldOrder={["incoterms", "incotermsLocationId", "freightTerms"]}
        />
      </Box>
    </form>
  )
}
